export const defaultData =  {
    "supplyForSale": 0,
    "fixedSalePrice": 0,
    "purchaseLimitsMax": 0,
    "numberOfTokens": 0,
    "registrationOpens": Date.now(),
    "registrationEnds": Date.now(),
    "salePeriodStart": Date.now(),
    "salePeriodEnd": Date.now(),
    "lockupAndRelease": {
        "numberOfParts": 0,
        "dates": [Date.now()],
        "numberOfTokens": 0

    },
    "participantNumber": 0,
    "numberOfContracts":0,
    "investmentAmount": 0,
    "totalNumberOfTokens": 0,
}